import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";
import { HiOutlineDocumentText } from "react-icons/hi"; // Professional icon for empty state
import banner1 from "../assets/banner1.jpg";
import OnePolicy from "./OnePolicy";

export default function ProgramsBanner(props) {
  const appContext = useContext(AppContext);
  const isProgramsPage = appContext.navItem === "programs";

  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await appContext.getAllPolicies();
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection bg-white" style={{ paddingBottom: "100px" }}>
      
      <div className="container pt-5 mt-4">
        {/* --- Section Header --- */}
        <div className="row justify-content-center mb-5">
          <div className="col-12">
            <header>
               <h2 className="w-header-title text-secondary text-start">Our Policies</h2>
                <p className="text-muted fs-5">
                  Ensuring transparency and excellence. Click on any policy below to download or view detailed documentation.
                </p>
            </header>
          </div>
          
        </div>

        {/* --- Policies Grid --- */}
        <div className="row g-4">
          {appContext.allPolicies && appContext.allPolicies.length > 0 ? (
            appContext.allPolicies.map((item, i) => (
              <div key={i} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={i * 50}>
                <div className="h-100 policy-card-wrapper">
                  <OnePolicy data={item} />
                </div>
              </div>
            ))
          ) : (
            <div className="col-md-12 py-5 text-center">
              <div className="mb-3 opacity-25">
                <HiOutlineDocumentText size={60} />
              </div>
              <h5 className="text-muted">No policies found at this time.</h5>
              <small className="text-muted">Please check back later for updates.</small>
            </div>
          )}
        </div>
      </div>

      <style>{`
        .policy-card-wrapper {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .policy-card-wrapper:hover {
          transform: translateY(-5px);
        }
        .text-extra {
          color: var(--secondaryColor) !important;
        }
        .MainBodySection {
          font-family: 'Inter', -apple-system, sans-serif;
        }
        .w-header-title {
          font-size: clamp(2.4rem, 6vw, 4.8rem);
          font-weight: 900;
          line-height: 1;
          letter-spacing: -0.06em;
          color: #fff;
          font-family: 'Inter', system-ui, sans-serif;
        }
      `}</style>
    </div>
  );
}